import { render, staticRenderFns } from "./CorporationRegistrationPopup.vue?vue&type=template&id=33172692&"
import script from "./CorporationRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./CorporationRegistrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports